import React from 'react';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';
import classNames from 'classnames';
import { useActivePremiumAchievementIcon } from '../../../../../hooks/shared/achievements/useActivePremiumAchievementIcon';
import { safeHTML } from '../../../../../utils/safeHTML';
import { useTranslation } from 'react-i18next';

export default function UserBillet({ userData = {}, modifier, onClick }) {
  const { score, username, iconId } = userData;

  const { t } = useTranslation();
  const iconImage = useActivePremiumAchievementIcon({ extraPremiumIcon: iconId });

  return (
    <div className={classNames('user-billet', ...combineModifiers('user-billet', modifier))} onClick={onClick}>
      <div className={'user-billet__main-info'}>
        <div
          className={classNames('user-billet__name', {
            ['user-billet__name_min']: username.length > 18 && iconImage,
          })}
        >
          {safeHTML(username)}
          {iconImage && <img src={iconImage} className={'user-billet__icon'} alt={''} />}
        </div>
      </div>
      <div className={'user-billet__score'}>{score}</div>
    </div>
  );
}
